import { NavLink } from "react-router-dom";
import { Container, Nav, Navbar } from "react-bootstrap";
import logo from "../../assets/images/logo.jpg";

const Header = () => {
  return (
    <header className="navbar-main">
      <Container>
        <Navbar
          collapseOnSelect
          expand="lg"
          className="navbar navbar-expand-lg"
        >
          <NavLink to="/" className="header-logo nav-link nav-info">
            <img src={logo} alt="sarthi-logo" className="logo" />
            <p className="logo-title">SARTHI INFOTECH</p>
          </NavLink>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            className="bg-light"
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto" navbarScroll>
              <NavLink to="/home" className="nav-link nav-info">
                Home
              </NavLink>
              <NavLink to="/about" className="nav-link nav-info">
                About
              </NavLink>
              <NavLink to="/contact-us" className="nav-link nav-info">
                Contact Us
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </header>
  );
};

export default Header;
